import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGrid2 } from "@fortawesome/pro-regular-svg-icons/faGrid2";

export const defaultTranslations = {
    pluginName: "Panel Grid",
    pluginDescription: "Add a panel grid",
};

export const defaultSettings = {
    Controls: () => <>Controls for this plugin were not provided</>,
    Renderer: () => <>Renderer for this plugin was not provided</>,
    translations: defaultTranslations,
    IconComponent: <FontAwesomeIcon icon={faGrid2} size="3x" />,
};
